<div class="order-info-card dropdown-content-root">
	<div class="order-header">
		<div class="inner">
			<div class="left">
				<div
					class="title"
					[tuiSkeleton]="isLoadingAssetInfo()"
				>
					<app-company-logo
						[logoSrc]="assetsInfo()?.icon"
						[symbol]="order()?.symbol"
						logoWidth="24px"
						logoHeight="24px"
						[logoAlt]="order()?.symbol"
					/>
					<p class="name">{{ assetsInfo()?.ticker }}</p>
				</div>
			</div>

			<div class="right">
				<span class="value">{{ order()?.created_at | date: 'dd.MM.yyyy / HH:mm:ss' }}</span>
				<tui-icon
					class="icon"
					icon="@tui.x"
					(click)="onCloseDropdown()"
				/>
			</div>
		</div>
	</div>

	<div class="order-body">
		@if (isComplexOrder()) {
			<div
				#orderWrap
				[class.oco-order]="isOCO()"
			>
				@if (!isOCO()) {
					<div
						#connector
						class="connector"
						[class.hidden]="isUpdatingConnectors()"
					>
						<tui-icon
							#connectorArrow
							class="arrow-bottom"
							icon="@tui.corner-down-right"
						/>
						@if (order()?.children_order?.length === 2) {
							<tui-icon
								#connectorArrow
								class="arrow-bottom"
								icon="@tui.corner-down-right"
							/>
						}
					</div>
				}

				@if (isOCO()) {
					<div
						#ocoConnector
						class="oco-connector"
						[class.hidden]="isUpdatingConnectors()"
					>
						<tui-icon
							class="arrow-top"
							icon="@tui.corner-up-right"
						/>
						<tui-icon
							class="arrow-bottom"
							icon="@tui.corner-down-right"
						/>
					</div>
				}

				@let orderHint = getOrderHints(order(), true);
				@if (orderHint) {
					<p class="disclaimer">
						{{ orderHint?.helpText || '' | translate }}
					</p>

					<ng-container
						*ngTemplateOutlet="orderHeader; context: { order: order(), hint: orderHint, headerIdx: 0 }"
					/>

					<tui-expand [expanded]="accordionExpandedHeaders()[0] ?? false">
						<app-order-info-body-detailed [order]="order()" />
					</tui-expand>

					<tui-expand [expanded]="!isAnyAccordionExpanded()">
						<app-order-info-body-preview [order]="order()" />
					</tui-expand>
				}

				<div
					[class.nested-orders]="!isOCO()"
					[class.oco-nested-orders]="isOCO()"
				>
					@for (child of order()?.children_order; track child?.id; let index = $index) {
						@let hint = getOrderHints(child, false, index);

						@if (hint) {
							<p class="disclaimer">
								{{ hint?.helpText || '' | translate }}
							</p>

							<ng-container
								*ngTemplateOutlet="
									orderHeader;
									context: {
										order: child,
										hint,
										headerIdx: index + 1,
									}
								"
							/>

							<tui-expand [expanded]="accordionExpandedHeaders()[index + 1] ?? false">
								<app-order-info-body-detailed [order]="child" />
							</tui-expand>

							<tui-expand [expanded]="!isAnyAccordionExpanded()">
								<app-order-info-body-preview [order]="child" />
							</tui-expand>
						}
					}
				</div>
			</div>
		} @else {
			@let orderHint = getOrderHints(order(), true);

			<ng-container *ngTemplateOutlet="orderHeader; context: { order: order(), hint: orderHint, headerIdx: 0 }" />
			<app-order-info-body-detailed [order]="order()" />
		}
	</div>
</div>

<ng-template
	#orderHeader
	let-order="order"
	let-hint="hint"
	let-headerIdx="headerIdx"
>
	<div
		highlight
		type="bg"
		#accordionHeader
		class="details-header"
		(click)="toggleAccordion(headerIdx)"
		[isPositive]="hasStatus(order, openOrderStatuses)"
		[isNegative]="hasStatus(order, cancelOrderStatuses)"
		[isNeutral]="hasStatus(order, filledOrderStatuses)"
		[class.header-only]="isComplexOrder() && isAnyAccordionExpanded() && !accordionExpandedHeaders()[headerIdx]"
		[class.simple-header]="!isComplexOrder()"
	>
		<div class="left">
			<p class="title">
				{{ hint?.title ?? 'ordersInfo.orderHints.bracket.main.title' | translate }}
			</p>
		</div>
		<div class="right">
			<span class="value">{{ 'ordersInfo.status.' + order?.status | translate }}</span>

			@if (isComplexOrder()) {
				<tui-icon
					icon="@tui.chevron-down"
					class="icon"
					[class.rotated]="accordionExpandedHeaders()[headerIdx]"
				/>
			}
		</div>
	</div>
</ng-template>
